"use strict";

import {init} from "@elements/alert-notification";

console.log('777');

init({
    // default options
});
